module.exports = __webpack_public_path__ + "static/media/ic_position_tilt.21c1cb64.png";